import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Restaurantregistrering',
  description: 'Trin {{activeStep}} af {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Grundoplysninger',
    [Step.BusinessDetails]: 'Virksomhedsoplysninger',
  },
  form: {
    name: {
      label: 'Restaurantens navn',
      placeholder: 'Indtast restaurantens navn',
    },
    timezone: {
      label: 'Tidszone',
      placeholder: 'Søg efter en by eller tidszone',
      inference_failed: 'Vi kunne ikke udlede tidszonen fra denne adresse – vælg den venligst.',
    },
    google_place: {
      label: 'Valgt Google-sted: {{name}}',
    },
    is_franchise: {
      label: 'Restauranten er en del af et brand',
    },
    sync_lieferando_brand: {
      label: 'Hent brandoplysninger (logo, primærfarve) fra Lieferando',
    },
    import_menu: {
      label: 'Importér menu',
    },
    lieferando_url: {
      label: 'Lieferando-URL',
      placeholder: 'Restaurantens URL på Lieferando',
    },
    other_platforms: {
      label: 'Nuværende leveringsplatforme',
      description: 'Vælg alle platforme, hvor I i øjeblikket er opført',
    },
    pos_system: {
      label: 'Nuværende kassesystem',
      placeholder: 'Vælg dit kassesystem',
      options: {
        [PosSystems.Other]: 'Andet',
      },
    },
    delivery_mode: {
      label: 'Leveringsmåde',
      placeholder: 'Vælg leveringsmåde',
      options: {
        [DeliveryMode.Internal]: 'Intern (egne chauffører)',
        [DeliveryMode.External]: 'Ekstern (tredjepart)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Månedligt leveringssalg',
      description: 'Samlet salg på tværs af alle leveringsplatforme',
      placeholder: 'Vælg salgsinterval',
      options: {
        other: 'Andet',
      },
      other: {
        placeholder: 'Indtast salgsbeløb',
      },
    },
    lead_source: {
      label: 'Leadkilde',
      description: 'Hvordan hørte du om os?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Opsøgende kontakt fra Sales Development Representative',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'Kom til os via hjemmeside eller marketing',
        },
        [LeadSources.Referral]: {
          title: 'Anbefaling – eksisterende restaurant',
          description: 'Anbefalet af en af vores partnerrestauranter',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Selvgenereret – kold',
          description: 'Fundet via kold opsøgning eller prospektering',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Selvgenereret – anbefaling',
          description: 'Personligt netværk eller kontakt',
        },
        [LeadSources.Tipster]: {
          title: 'Tipster',
          description: 'Foodamigos betaler person/virksomhed X en provision for anbefalingen',
        },
      },
    },
    sdr: {
      description: 'Vælg den SDR, der er ansvarlig for at finde dette lead',
    },
    has_instagram_profile: {
      label: 'Instagram-profil',
      description: 'Har din restaurant en Instagram-profil?',
      options: {
        true: 'Ja',
        false: 'Nej',
      },
    },
  },
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
    complete_registration: 'Fuldfør registrering',
  },
  basic_information: {
    title: 'Grundlæggende oplysninger',
    description: 'Indtast restaurantens grundlæggende oplysninger og kontaktinformation',
  },
  additional_options: {
    title: 'Yderligere indstillinger',
    description: 'Konfigurer yderligere indstillinger for denne restaurant',
  },
  restaurant_type: {
    title: 'Restauranttype og servicemodel',
    description: 'Vælg det format, der bedst beskriver denne restaurants servicestil',
  },
  cuisine_type: {
    title: 'Madkategorier og køkkentyper',
    description: 'Vælg alle madkategorier og køkkentyper, der gælder for denne restaurant',
    placeholder: 'Søg køkkentyper',
  },
  business_details: {
    title: 'Virksomhedsoplysninger',
    description: 'Hjælp os med at forstå din nuværende drift',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restaurant med bordbetjening',
      description: 'Servering ved bordet med bordbetjening',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Bestil ved disken/i appen, højere kvalitet og mere tilpasning end QSR, valgfri siddeplads',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Quick Service (QSR) / Takeaway',
      description: 'Hurtig betjening ved disken; primært takeaway',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café og bageri',
      description: 'Kaffe, wienerbrød, lette måltider, morgenmad/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Dessert og is',
      description: 'Koncepter med fokus på søde sager',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Drinks og bar',
      description: 'Steder med fokus på drikkevarer; mad valgfri; alkoholudbringning er underlagt lokale regler',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Kun levering / Ghost Kitchen',
      description: 'Ingen butik; virtuelle brands og cloud kitchens',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgere',
    [CuisineTypes.ChickenFried]: 'Friturestegt kylling',
    [CuisineTypes.Wings]: 'Wings',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Sandwiches',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Salater',
    [CuisineTypes.Healthy]: 'Sundt',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegansk',
    [CuisineTypes.Vegetarian]: 'Vegetarisk',
    [CuisineTypes.GlutenFree]: 'Glutenfri',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japansk',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Koreansk',
    [CuisineTypes.KoreanFriedChicken]: 'Koreansk stegt kylling',
    [CuisineTypes.Chinese]: 'Kinesisk',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Kantonesisk/Dim Sum',
    [CuisineTypes.Thai]: 'Thai',
    [CuisineTypes.Vietnamese]: 'Vietnamesisk',
    [CuisineTypes.Malaysian]: 'Malaysisk',
    [CuisineTypes.Indonesian]: 'Indonesisk',
    [CuisineTypes.Filipino]: 'Filippinsk',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indisk',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistansk',
    [CuisineTypes.SriLankan]: 'Srilankansk',
    [CuisineTypes.Nepalese]: 'Nepalesisk',

    [CuisineTypes.Turkish]: 'Tyrkisk',
    [CuisineTypes.Lebanese]: 'Libanesisk',
    [CuisineTypes.Syrian]: 'Syrisk',
    [CuisineTypes.Israeli]: 'Israelsk',
    [CuisineTypes.Egyptian]: 'Egyptisk',
    [CuisineTypes.PersianIranian]: 'Persisk/Iransk',
    [CuisineTypes.Iraqi]: 'Irakisk',
    [CuisineTypes.Afghan]: 'Afghansk',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Græsk',
    [CuisineTypes.Mediterranean]: 'Middelhavskøkken',

    [CuisineTypes.Italian]: 'Italiensk',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Fransk',
    [CuisineTypes.SpanishTapas]: 'Spansk/Tapas',
    [CuisineTypes.Portuguese]: 'Portugisisk',
    [CuisineTypes.German]: 'Tysk',
    [CuisineTypes.Austrian]: 'Østrigsk',
    [CuisineTypes.Balkan]: 'Balkan',
    [CuisineTypes.Hungarian]: 'Ungarsk',
    [CuisineTypes.Polish]: 'Polsk',
    [CuisineTypes.Czech]: 'Tjekkisk',
    [CuisineTypes.Georgian]: 'Georgisk',

    [CuisineTypes.Mexican]: 'Mexicansk',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruviansk',
    [CuisineTypes.Brazilian]: 'Brasiliansk',
    [CuisineTypes.Argentinian]: 'Argentinsk',
    [CuisineTypes.Caribbean]: 'Caribisk',
    [CuisineTypes.BBQAmerican]: 'BBQ/amerikansk',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Amerikansk (generelt)',
    [CuisineTypes.HotDogs]: 'Hotdogs',

    [CuisineTypes.Seafood]: 'Fisk og skaldyr',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Dampet fisk',

    [CuisineTypes.BreakfastBrunch]: 'Morgenmad/brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Bageri',
    [CuisineTypes.PastryDessert]: 'Wienerbrød/dessert',
    [CuisineTypes.WafflesCrepes]: 'Vafler/crepes',
    [CuisineTypes.IceCreamGelato]: 'Is/gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Kager',

    [CuisineTypes.CoffeeCafe]: 'Kaffe/café',
    [CuisineTypes.BubbleTea]: 'Bubble tea',
    [CuisineTypes.JuiceSmoothies]: 'Juice/smoothies',
    [CuisineTypes.Milkshakes]: 'Milkshakes',
    [CuisineTypes.BarPub]: 'Bar/pub',
    [CuisineTypes.WineBar]: 'Vinbar',
    [CuisineTypes.Cocktails]: 'Cocktails',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/mezze/små retter',
    [CuisineTypes.Noodles]: 'Nudler',
    [CuisineTypes.Soup]: 'Suppe',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul food',
    [CuisineTypes.ComfortFood]: 'Comfort food',
    [CuisineTypes.StreetFood]: 'Street food',
    [CuisineTypes.OrganicBio]: 'Økologisk/bio',
    [CuisineTypes.KidsMenu]: 'Børnemenu',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/generelt',
    [CuisineCategories.AsianPacific]: 'Asiatisk/Stillehav',
    [CuisineCategories.SouthAsian]: 'Sydasiatisk',
    [CuisineCategories.MiddleEastMediterranean]: 'Mellemøsten/Middelhavet',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Amerika',
    [CuisineCategories.SeafoodSpecialty]: 'Specialiteter med fisk og skaldyr',
    [CuisineCategories.BreakfastBakerySweets]: 'Morgenmadsbageri/sødt',
    [CuisineCategories.BeverageLed]: 'Drikkevarebaseret',
    [CuisineCategories.OtherConcepts]: 'Andre koncepter',
  },
};
